// extracted by mini-css-extract-plugin
export default {"form":"UploadDocumentModal_form__aXNaU","fileError":"UploadDocumentModal_fileError__AJWPJ","patientError":"UploadDocumentModal_patientError__5sBNK"};